import type { SignInResponse } from '../types/auth';

const STORAGE_KEY = 'friends-for-life-auth-session';

function withAccessTokenExpiry(response: SignInResponse): SignInResponse {
  return {
    ...response,
    data: {
      ...response.data,
      accessTokenExpiresAt: Date.now() + response.data.expiresIn * 1000,
    },
  };
}

export function readStoredSession(): SignInResponse | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SignInResponse;
    if (!parsed?.success || !parsed?.data?.accessToken) return null;
    if (!parsed.data.user?.userId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeStoredSession(response: SignInResponse): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(withAccessTokenExpiry(response)),
    );
  } catch {
    // ignore quota / private mode
  }
}

export function clearStoredSession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
